import PropTypes from "prop-types";
import { memo } from "react";
import QuotationBoard from "app/pages/Booking/Quotation/Board/QuotationBoard";
import { messagePropType, quotationBoardShape } from "app/utils/propTypes";
import "./QuotationBoards.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const QuotationBoards = ({
	boards = [],
	onChange,
	title,
	accommodationUpgradePrice = 0,
	isAccommodationIncluded,
}) => {
	return (
		<div className="quotation-boards">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.LARGE}
				isBold
				className="quotation-boards__subtitle"
				component="h3"
			>
				{title}
			</Typography>
			{boards.map(board => {
				return (
					<div
						className="quotation-boards__item"
						key={board.code}
						data-testid="quotation-board-item"
					>
						<QuotationBoard
							onChange={onChange}
							board={board}
							accommodationUpgradePrice={accommodationUpgradePrice}
							isAccommodationIncluded={isAccommodationIncluded}
						/>
					</div>
				);
			})}
		</div>
	);
};

QuotationBoards.propTypes = {
	boards: PropTypes.arrayOf(quotationBoardShape),
	onChange: PropTypes.func,
	accommodationUpgradePrice: PropTypes.number,
	isAccommodationIncluded: PropTypes.bool,
	title: messagePropType,
};

export default memo(QuotationBoards);
